<template>
  <div>
    <div class="tree-item" :class="{ 'is-active': isSelected }" @click="selectSelf">
      <button
          v-if="hasChildren"
          type="button"
          class="tree-expand-btn"
          @click.stop="expanded = !expanded"
      >
        <svg
            :class="['chevron', expanded ? 'chevron-expanded' : '']"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        ><polyline points="15 18 9 12 15 6"></polyline></svg>
      </button>
      <span v-else class="tree-expand-spacer"></span>

      <span class="tree-name">{{ category.name }}</span>

      <span v-if="category.product_count != null" class="tree-count">{{ formatNumber(category.product_count) }}</span>
    </div>

    <div v-if="expanded && hasChildren" class="tree-children">
      <category-seo-tree-node
          v-for="child in category.children"
          :key="child.id"
          :category="child"
          :selected-id="selectedId"
          @select="$emit('select', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CategorySeoTreeNode",
  props: {
    category: { type: Object, required: true },
    selectedId: { type: [Number, String], default: null },
  },
  data() {
    return { expanded: false };
  },
  computed: {
    hasChildren() {
      return this.category.children && this.category.children.length > 0;
    },
    isSelected() {
      return this.selectedId === this.category.id;
    },
  },
  methods: {
    selectSelf() {
      this.$emit("select", this.category);
    },
    formatNumber(val) {
      if (val === null || val === undefined) return "۰";
      return Number(val).toLocaleString("fa-IR");
    },
  },
};
</script>

<style scoped>
.tree-item {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12.5px;
  color: #a8b2c7;
  border: 1px solid transparent;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.tree-item:hover {
  background: #162238;
  color: #f8fafc;
}
.tree-item.is-active {
  background: rgba(117, 87, 255, 0.18);
  border-color: #7557ff;
  color: #ffffff;
  font-weight: 700;
}
.tree-expand-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  background: transparent;
  border: none;
  color: #6e7b94;
  padding: 0;
  cursor: pointer;
}
.tree-item.is-active .tree-expand-btn {
  color: #ffffff;
}
.tree-expand-spacer {
  width: 18px;
  flex-shrink: 0;
}
.chevron {
  width: 14px;
  height: 14px;
  transition: transform 0.15s ease;
}
.chevron-expanded {
  transform: rotate(-90deg);
}
.tree-name {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tree-count {
  flex-shrink: 0;
  background: #1c2941;
  color: #a8b2c7;
  font-size: 10px;
  line-height: 1;
  padding: 3px 7px;
  border-radius: 999px;
}
.tree-item.is-active .tree-count {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}
.tree-children {
  margin-right: 14px;
  padding-right: 10px;
  border-right: 1px solid #1c2941;
}
</style>
